import { formatUnits } from "viem";

/** wei amount → trimmed decimal string, e.g. 12500000000000000000n, 18 → "12.5" */
export function formatTokenAmount(wei: bigint, decimals: number): string {
  return formatUnits(wei, decimals)
    .replace(/(\.\d*?)0+$/, "$1")
    .replace(/\.$/, "");
}

/**
 * Thrown by the pre-flight balance check. `name` is checked by
 * transaction-logger's categorizeError — the thrown `message` is a
 * localized (fa/ar/en) string, so it can't be pattern-matched itself.
 */
export class InsufficientBalanceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "InsufficientBalanceError";
  }
}
